module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [_vm.selected ? 'selected' : ''],
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d4c58bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selector/selector-item.vue
// module id = 34
// module chunks = 1 4 16